import { Person } from './Person';
import { PrivilegeGroup, Privilege } from "./UserRelationship";

export class PartnerUser {
    Person?: Person;
    IsPrimary?: boolean;
    CanAddUser: boolean;
    UniqueKey?: string;
    IsActive?: boolean;
    CreatedAt?: string;
    UpdatedAt?: string;
    CreatedByEmail?: string;
    UpdatedByEmail?: string;
    Privileges?: Privilege[];
    PrivilegeGroups?: PrivilegeGroup[];
    NewPrimaryContactId?: number;
    constructor() {
    }
}
